module.exports = __webpack_public_path__ + "img/2023big3.afc0b2b5.png";